/**
 * Created by Tiger on 04/03/2022.
 */
import {Form, Select} from 'antd';
import React from 'react';

export const SelectItem = item => {
  const { placeholder = '', label = undefined, style = {},onChanged, defaultValue, onSelect,defaultId, ...selectParams } = item;
  return (<Form.Item style={ { marginTop: label ? 15 : 0, ...style } }>
    { label && <label>{ label }</label> }
    <Select style={ { marginTop: label ? 10 : 0 } } optionFilterProp={ 'label' } labelInValue={ true }
            showSearch={ true } showArrow={ true }
            allowClear={ true }
            defaultValue={ defaultId}
            placeholder={ placeholder } { ...selectParams }
            onChange={ e => onChanged?.(e) }
            onSelect={ value => onSelect?.(value) }
    />
  </Form.Item>);
};
